import { PlayerProfile } from "./profile";
import { canFinishFree, finishFree } from "./upgradeQueue";
import { Wallet } from "./wallet";

/**
 * FINISH NOW (MP-07 (a), owner D2 2026-10-12; shop.json `finishNow`): a running upgrade — a tower's or the fortress's —
 * ends at once for gems. The price is the speed-up curve's: ceil(time left / `stepMinutes`) steps, at least `minSteps`,
 * × `gemsPerStep` (15 gems an hour, the 1 h speed-up's price). Under VIP's free finish (`freeFinishMinutes`) it costs
 * nothing and is that perk. Bought from the hub only (@highmarch/app Economy.finishNow; the never list); ledger reason
 * `finishNow`, ref `job<id>`. The caller claims what completed (PlayerProfile.claimCompleted).
 */

const SECONDS_PER_MINUTE = 60;

/** Gems to finish job `jobId` at `now`: 0 under the VIP free finish; or why it cannot be finished. */
export function finishNowPrice(p: PlayerProfile, jobId: number, now: number): number | string {
  const job = p.jobs.find((j) => j.id === jobId);
  if (!job) return "no such job";
  const left = job.endAt - now;
  if (left <= 0) return "already complete";
  if (canFinishFree(p, jobId, now) === true) return 0;
  const f = p.balance.commerce.shop.finishNow;
  if (f.gemsPerStep <= 0) return "no such product";
  return Math.max(f.minSteps, Math.ceil(left / (f.stepMinutes * SECONDS_PER_MINUTE))) * f.gemsPerStep;
}

/**
 * Finishes job `jobId` now: free under the VIP threshold, else for `finishNowPrice` gems — refused when the wallet
 * holds fewer ("not enough gems") or the price moved past `shownPrice` (the player is never charged more than they saw:
 * "offer changed"). Its end moves to `now`; returns the gems paid.
 */
export function finishNow(p: PlayerProfile, wallet: Wallet, jobId: number, now: number, shownPrice: number): number | string {
  const price = finishNowPrice(p, jobId, now);
  if (typeof price === "string") return price;
  if (price > shownPrice) return "offer changed";
  if (price === 0) { const ok = finishFree(p, jobId, now); return ok === true ? 0 : ok; }
  const paid = wallet.spend("gems", price, "finishNow", now, `job${jobId}`);
  if (paid !== true) return paid;
  p.jobs.find((j) => j.id === jobId)!.endAt = now;
  return price;
}
